import { QuoteUnderwritingTaskSearchRequestQuery } from '@lio/api-types';

export const underwritingTasksQueryKeys = {
  all: ['underwritingTasks'] as const,
  underwritingTasks: (id: string) => [...underwritingTasksQueryKeys.all, id] as const,
  searchUnderwritingTasks: () => [...underwritingTasksQueryKeys.all] as const,
  searchWithParams: (params?: QuoteUnderwritingTaskSearchRequestQuery & { quoteId: string }) =>
    [...underwritingTasksQueryKeys.searchUnderwritingTasks(), params] as const,
};
